import { useContext } from 'react'

import { ModalContext } from '../../provider/modalProvider'

export const Modals = () => {
  const { modals } = useContext(ModalContext)

  return (
    <>
      {/* Modal 여러개가 중첩되는 상황을 대비해서 context에 배열로 modal 정보를 넣고 map 돌려서 render */}
      {modals?.map(({ Component, props }, index) => {
        return <Component key={index} {...props} />
      })}
    </>
  )
}
